var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(_vm.$route.meta.nave)?_c('nave'):_vm._e(),_c('router-view'),(_vm.$route.meta.foter)?_c('foter',{attrs:{"id":"bot"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }